import { AfterViewInit, Component, ElementRef, HostListener, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare global {
  interface Window {
    AndroidInterface?: {
      closeWebView: () => void;
    };
  }
}

import { CredentialsService } from '@app/auth';
import { HeaderService } from './header.service';
import { BankPageService } from '@app/pages/bank-page/bank-page.service';
import { PaymentPlansService } from '@app/pages/payment-plans/payment-plans.service';
import { OrderJSON } from '@app/@shared/orderjson.model';
import { isIncompleteResubmission } from '@app/@shared/order-resubmission';
import { AuthenticationService } from '@app/auth';
import { SessionStorageService } from '@app/sessionStorage.service';
import { AgreementsPageService } from '@app/pages/agreements-page/agreements-page.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  private readonly businessInfoBackRouteKey = 'businessInfoBackRoute';
  public menuHidden: boolean = true;
  public nextPage: string = '';
  public previousPage: string = '';
  public currentPage = '/';
  public pageSubTitle = '';
  public pageTitle = '';
  public displayNavButtons: boolean = true;
  public displayHeader: boolean = true;
  public displayEmailVerification: boolean = false;
  public step = 1;
  public totalSteps = 12;
  public progress = 25;
  public hideBackbutton: boolean = false;
  public hideNextButton: boolean = false;
  public disableNxtBtn: boolean = false;
  public isExistingUser: boolean = false;
  public softwarePlansPage: boolean = false;
  public nrspayPlansPage: boolean = false;
  public equipmentServicesPage: boolean = false;
  public ramJson = new OrderJSON();
  public isAgreementPage: boolean = false;
  public isSuccessPage: boolean = false;
  public bankPage: boolean = false;
  public paymentPlansPage: boolean = false;
  public waringDisplayHeader: boolean = false;
  public errorMesssge: string = '';
  public isSummaryPage: boolean = false;
  //public agreementPage:boolean=false;
  softwareFeaturePage: boolean = false;
  personalInfoPage: boolean = false;
  disableBackBtn: boolean = false;
  // Once any agreement/contract is signed we lock the stepper and Back button:
  // the signed documents are not regenerated, so the user must not be able to
  // go back and change anything on prior pages.
  public navigationLocked: boolean = false;
  // Signed order sent back as "incomplete": steps and Back stay enabled except the first step.
  public isResubmissionFlow: boolean = false;
  private softwarePlansTimeout: any;
  private nrsPayTimeout: any;

  // Step labels for the stepper progress bar
  @ViewChild('stepperContainer', { static: false }) stepperContainer?: ElementRef<HTMLElement>;
  @ViewChildren('stepperItem') stepperItems?: QueryList<ElementRef<HTMLElement>>;
  @ViewChild('unsavedChangesModal', { static: false }) unsavedChangesModal?: TemplateRef<any>;
  private lastScrolledStep: number | null = null;
  private resizeHandler = () => this.scheduleActiveStepScroll();

  // Route the user is trying to reach via the stepper or the Back button while
  // the unsaved-changes prompt is open.
  private pendingStepRoute: string | null = null;

  public stepLabels: string[] = [
    'SELECT POS',
    'SOFTWARE',
    'NRS PAY',
    'ACCOUNT',
    'DETAILS',
    'BANK SETUP',
    'FEATURES',
    'EQUIPMENT',
    'SUMMARY',
    'PAYMENT'
  ];
  public maxVisitedStepIndex = -1;
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    public  headerService: HeaderService,
    private bankPageService: BankPageService,
    private paymentPlansService: PaymentPlansService,
    private authService: AuthenticationService,
    private sessionStorageService: SessionStorageService,
    private agreementsPageService: AgreementsPageService,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.waringDisplayHeader = false;
    this.agreementsPageService.currentValue.subscribe((message) => {
      this.refreshResubmissionFlow(this.sessionStorageService.getAllData() as OrderJSON);
      this.disableBackBtn = message && !this.isResubmissionFlow;
      // Signing emits `true` here; lock navigation for the rest of the session.
      if (message && !this.isResubmissionFlow) {
        this.navigationLocked = true;
      }
    });
    this.bankPageService.currentValue.subscribe(() => this.syncNextButtonDisabled());
    this.paymentPlansService.currentValue.subscribe(() => this.syncNextButtonDisabled());
    this.headerService._existingUser.subscribe((value) => {
      this.ramJson = this.sessionStorageService.getAllData() as OrderJSON;
      this.loadMaxVisitedStep();
      console.log("existing user", value);
      if (this.headerService.existingUser) {
        this.isExistingUser = true;
      } else {
        this.hideBackbutton = false;
        this.isExistingUser = false;
      }
      this._updateHeaderState(this.headerService.currentPageConfiguration);
    });

    this.headerService.pageConfiguration$.subscribe((config) => {
      this._updateHeaderState(config);
      this.scheduleActiveStepScroll();
    });
    this.headerService.isHeader.subscribe((msg: any) => (this.displayHeader = msg));
  }

  ngAfterViewInit(): void {
    this.stepperItems?.changes.subscribe(() => this.scheduleActiveStepScroll());
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.resizeHandler);
    }
    this.scheduleActiveStepScroll();
  }

  /**
   * Drag-to-scroll support for the stepper. The native horizontal scrollbar
   * is hidden (the user wanted no scrollbar), so the only way to see items
   * past the viewport edge on desktop is click-and-drag.
   */
  private isDraggingStepper = false;
  private dragStartX = 0;
  private dragStartScrollLeft = 0;
  private stepperHasOverflow = false;
  private stepperDragged = false;

  public onStepperMouseDown(event: MouseEvent): void {
    if (!this.stepperContainer || event.button !== 0) {
      return;
    }
    const container = this.stepperContainer.nativeElement;
    this.stepperHasOverflow = container.scrollWidth > container.clientWidth + 1;
    if (!this.stepperHasOverflow) {
      return;
    }
    this.stepperDragged = false;
    this.isDraggingStepper = true;
    this.dragStartX = event.pageX;
    this.dragStartScrollLeft = container.scrollLeft;
    container.classList.add('is-dragging');
    // Prevent text selection and the browser's image/link drag ghosting
    // while the user is scrubbing the stepper.
    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  public onStepperMouseMove(event: MouseEvent): void {
    if (!this.isDraggingStepper || !this.stepperContainer) {
      return;
    }
    const container = this.stepperContainer.nativeElement;
    const delta = event.pageX - this.dragStartX;
    if (Math.abs(delta) > 5) {
      this.stepperDragged = true;
    }
    const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);
    const target = this.dragStartScrollLeft - delta;
    container.scrollLeft = Math.min(Math.max(target, 0), maxLeft);
  }

  @HostListener('document:mouseup')
  public onStepperMouseUp(): void {
    if (!this.isDraggingStepper || !this.stepperContainer) {
      return;
    }
    this.isDraggingStepper = false;
    this.stepperContainer.nativeElement.classList.remove('is-dragging');
  }

  /**
   * Centers the currently active step inside the stepper container.
   * Skips work when nothing has changed since the last scroll. Auto-runs on
   * both mobile and narrow desktop viewports where the bar overflows.
   */
  private scheduleActiveStepScroll(): void {
    if (!this.stepperContainer || !this.stepperItems || this.step <= 0) {
      return;
    }
    if (this.lastScrolledStep === this.step) {
      return;
    }

    // Wait one frame so the DOM reflects the latest *ngIf / class bindings.
    requestAnimationFrame(() => {
      const container = this.stepperContainer?.nativeElement;
      const items = this.stepperItems?.toArray() ?? [];
      const activeIndex = this.step - 1;
      const activeItem = items[activeIndex]?.nativeElement;
      if (!container || !activeItem) {
        return;
      }

      // If the stepper fits without overflowing, there's nothing to scroll.
      if (container.scrollWidth <= container.clientWidth + 1) {
        this.lastScrolledStep = this.step;
        return;
      }

      const containerRect = container.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();
      const itemCenter = itemRect.left + itemRect.width / 2;
      const containerCenter = containerRect.left + containerRect.width / 2;
      const offset = itemCenter - containerCenter;

      const targetLeft = container.scrollLeft + offset;
      const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);
      const clampedLeft = Math.min(Math.max(targetLeft, 0), maxLeft);

      container.scrollTo({ left: clampedLeft, behavior: 'smooth' });
      this.lastScrolledStep = this.step;
    });
  }

  private _updateHeaderState(config: any): void {
    if (!config) {
      // Handle case where configuration might be initially null or undefined
      this.displayHeader = false;
      return;
    }
    this.previousPage = config.previousPage;
    this.nextPage = config.nextPage;
    this.pageSubTitle = config.subTitle;
    this.pageTitle = config.title;
    this.progress = config.progress;
    this.step = config.step;
    this.syncRamJsonFromSession();
    this.updateMaxVisitedStep();
      // Update total steps dynamically based on current flow
    this.totalSteps = this.headerService.totalStepsForCurrentFlow;
    // Update stepper labels dynamically based on current flow (POS-only flows
    // omit "NRS PAY", NRS Pay-only flows omit "SOFTWARE", etc.)
    this.stepLabels = this.headerService.stepLabelsForCurrentFlow;
    this.isAgreementPage = config.currentPage === '/agreements';
    this.isSuccessPage = config.currentPage === '/success';
    this.currentPage = config.currentPage;
    this.displayNavButtons = true;
    this.displayHeader = true;
    this.hideNextButton = false;
    this.hideBackbutton = false;
    this.softwarePlansPage = false;
    this.disableNxtBtn = false;
    this.isSummaryPage = false;
    this.equipmentServicesPage = false;
    this.softwareFeaturePage = false;
    this.personalInfoPage = false;
    this.nrspayPlansPage = false;
    this.bankPage = false;
    this.paymentPlansPage = false;
    this.displayEmailVerification = false;
    
    // Clear any pending timeouts when updating header state
    clearTimeout(this.softwarePlansTimeout);
    clearTimeout(this.nrsPayTimeout);
    
    const cleanUrl = config.currentPage.split('?')[0];
    switch (cleanUrl) {
      case '/subscription':
        this.nextPage = config.nextPage;
        this.resetMaxVisitedStep();
        break;

      case '/success':
        break;

      case '/login':
      case '/recover-password':
      case '/create-password':
      case '/wizard':
      case '/wizard/best-fit':
        this.displayHeader = false;
        break;

      case '/email-verification':
        this.displayHeader = false;
        this.displayEmailVerification = true;
        break;

      case '/software-plans':
        this.softwarePlansPage = true;
        console.log("this.ramJson.subscriptionType", this.ramJson.subscriptionType);
        if(this.ramJson.subscriptionType == 'POS+') {
          this.nextPage = '/business-information';
        }
        this.softwarePlansTimeout = setTimeout(() => {
          console.log("clean url from set timeout", cleanUrl);
          if (this.isExistingUser || this.headerService.isPantherTablet) {
            this.hideBackbutton = true;
          }
        });
        break;
      case '/software-features':
        this.softwareFeaturePage = true;
        break;

      case '/nrspay-plans':
        this.nrspayPlansPage = true;
        this.nrsPayTimeout = setTimeout(() => {
          if (this.isExistingUser && this.ramJson?.subscriptionType === 'NRSPAY') {
            this.hideBackbutton = true;
          } else {
            this.hideBackbutton = false;
          }
        });
        break;

      case '/equipment-services':
        this.equipmentServicesPage = true;
        break;

      case '/bank-page':
        this.bankPage = true;
        // Stay disabled until the bank page reports a successful submit.
        this.disableNxtBtn = this.bankPageService.isNextBtnDisabled;
        if (this.ramJson?.subscriptionType === 'NRSPAY') {
          this.nextPage = '/summary';
        }
        break;

      case '/payment-plans':
        this.paymentPlansPage = true;
        // Stay disabled until at least one payment method is added.
        this.disableNxtBtn = this.paymentPlansService.isNextBtnDisabled;
        break;

      case '/business-information':
        if(this.ramJson.subscriptionType == 'POS+') {
          this.nextPage = '/software-features';
        }
        break;

      case '/summary':
        this.isSummaryPage = true;
        break;
    }
  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }

  signout() {
    // clear session and navigate to landing page
    sessionStorage.clear();
    this.router.navigate(['/'], { replaceUrl: true });
  }

  get username(): string | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials.username : null;
  }

  private syncNextButtonDisabled() {
    if (this.bankPage) {
      this.disableNxtBtn = this.bankPageService.isNextBtnDisabled;
      return;
    }
    if (this.paymentPlansPage) {
      this.disableNxtBtn = this.paymentPlansService.isNextBtnDisabled;
      return;
    }
    this.disableNxtBtn = false;
  }

  public onClickNext() {
    if ((this.bankPage || this.paymentPlansPage) && this.disableNxtBtn) {
      return;
    }
    if (this.isSuccessPage) {
      // Keep the user logged in and take them into the account portal dashboard.
      const orderData = this.sessionStorageService.getAllData() as OrderJSON;
      this.sessionStorageService.saveData(orderData, SessionStorageService.EXISTING_ORDER_FLOW);
      this.router.navigate(['/', 'account-portal'], { replaceUrl: true });
      return;
    }
    if (this.currentPage === '/business-information') {
      sessionStorage.removeItem(this.businessInfoBackRouteKey);
    }
    this.headerService.onNext(() => {
      console.log("nextPage", this.nextPage);
      this._navigate(this.nextPage, false);
    });
  }

  public onStepClick(stepIndex: number, event: MouseEvent): void {
    if (this.stepperDragged) {
      return;
    }
    // Navigation is locked after an agreement is signed.
    if (this.navigationLocked) {
      return;
    }
    if (this.isStepDisabled(stepIndex)) {
      return;
    }
    // Only allow navigation to steps the user has already reached.
    if (stepIndex > this.maxVisitedStepIndex) {
      return;
    }
    const targetRoute = this.headerService.getRouteForStepLabelIndex(stepIndex);
    if (!targetRoute || targetRoute === this.currentPage.split('?')[0]) {
      // No route, or the user clicked the step they are already on.
      return;
    }
    // If the current page has unsaved changes, ask the user what to do before
    // leaving. Otherwise navigate straight away.
    if (this.headerService.isCurrentPageDirty()) {
      this.pendingStepRoute = targetRoute;
      this.openUnsavedChangesModal();
    } else {
      this._navigate(targetRoute, false);
    }
  }

  /**
   * Opens the "unsaved changes" confirmation before leaving the current page via
   * the stepper or the Back button. Save runs the same pre-navigation save hooks
   * the Next button uses; Discard leaves without saving; Cancel/dismiss stays on
   * the page.
   */
  private openUnsavedChangesModal(): void {
    const targetRoute = this.pendingStepRoute;
    if (!this.unsavedChangesModal) {
      // Defensive fallback: without the template we cannot prompt, so just go.
      this.pendingStepRoute = null;
      this._navigate(targetRoute, false);
      return;
    }
    this.modalService
      .open(this.unsavedChangesModal, { centered: true, backdrop: 'static' })
      .result.then(
        (action: string) => {
          const route = this.pendingStepRoute;
          this.pendingStepRoute = null;
          if (action === 'save') {
            // Persist via the page's registered hooks, then navigate.
            this.headerService.onNext(() => this._navigate(route, false));
          } else if (action === 'discard') {
            // Skip the page's save hooks and navigate, losing the changes.
            this.headerService.preNavigationHooks = [];
            this._navigate(route, false);
          }
        },
        () => {
          // Dismissed (Cancel / backdrop / Esc): stay on the current page.
          this.pendingStepRoute = null;
        },
      );
  }

  public isStepDisabled(stepIndex: number): boolean {
    return (
      (this.isExistingUser || this.isResubmissionFlow) &&
      this.headerService.getRouteForStepLabelIndex(stepIndex) === '/subscription'
    );
  }

  private loadMaxVisitedStep(): void {
    const currentFlow = this.headerService.stepLabelsForCurrentFlow.join('|');
    if (this.ramJson.maxVisitedStepFlow === currentFlow && typeof this.ramJson.maxVisitedStepIndex === 'number') {
      this.maxVisitedStepIndex = this.ramJson.maxVisitedStepIndex;
    } else {
      this.maxVisitedStepIndex = -1;
      this.ramJson.maxVisitedStepIndex = -1;
      this.ramJson.maxVisitedStepFlow = currentFlow;
      this.persistRamJson();
    }
  }

  private updateMaxVisitedStep(): void {
    const currentStepIndex = this.step - 1;
    if (currentStepIndex > this.maxVisitedStepIndex) {
      this.maxVisitedStepIndex = currentStepIndex;
      this.ramJson.maxVisitedStepIndex = currentStepIndex;
      this.ramJson.maxVisitedStepFlow = this.headerService.stepLabelsForCurrentFlow.join('|');
      this.persistRamJson();
    }
  }

  private resetMaxVisitedStep(): void {
    this.maxVisitedStepIndex = -1;
    this.ramJson.maxVisitedStepIndex = -1;
    this.ramJson.maxVisitedStepFlow = this.headerService.stepLabelsForCurrentFlow.join('|');
    this.persistRamJson();
  }

  private persistRamJson(): void {
    this.sessionStorageService.saveData(this.ramJson, SessionStorageService.NEW_ORDER_FLOW);
    this.headerService.persistOrderMetadata(this.ramJson);
  }

  private syncRamJsonFromSession(): void {
    const fromSession = this.sessionStorageService.getAllData() as OrderJSON;
    if (fromSession && Object.keys(fromSession).length > 0) {
      this.ramJson = fromSession;
      this.refreshResubmissionFlow(fromSession);
      const currentFlow = this.headerService.stepLabelsForCurrentFlow.join('|');
      if (this.ramJson.maxVisitedStepFlow === currentFlow && typeof this.ramJson.maxVisitedStepIndex === 'number') {
        this.maxVisitedStepIndex = this.ramJson.maxVisitedStepIndex;
      }
      // Lock navigation once any agreement has been signed; the flag is never
      // cleared afterwards so the user cannot go back and alter signed docs.
      if (
        !this.isResubmissionFlow &&
        (this.ramJson.isNRSPAYServiceAgrementSigned || this.ramJson.isPlatFormServiceAgrementSigned)
      ) {
        this.navigationLocked = true;
      }
    }
  }

  private refreshResubmissionFlow(order: OrderJSON): void {
    const completedOrder = this.sessionStorageService.getAllData(SessionStorageService.EXISTING_ORDER_FLOW);
    const hasCompletedOrder = !!completedOrder && Object.keys(completedOrder).length > 0;
    this.isResubmissionFlow = isIncompleteResubmission(order) && !hasCompletedOrder;
  }

  public onClickPrevious() {
    // Navigation is locked after an agreement is signed; ignore Back requests.
    if (this.navigationLocked) {
      return;
    }
    if (!this.ramJson || this.ramJson.subscriptionType === '') {
      this.ramJson = this.sessionStorageService.getAllData() as OrderJSON;
      if (!this.ramJson) {
        console.error("Failed to load ramJson from session storage for back navigation.");
        this._navigate(this.previousPage);
        return;
      }
    }

    let targetRoute = this.previousPage;

    if (this.currentPage === '/business-information') {
      const businessInfoBackRoute = sessionStorage.getItem(this.businessInfoBackRouteKey);
      if (businessInfoBackRoute === '/wizard/best-fit') {
        targetRoute = '/wizard/best-fit';
        sessionStorage.removeItem(this.businessInfoBackRouteKey);
      }
    }

    switch (this.ramJson.subscriptionType) {
      case 'POS+':
        if (this.softwareFeaturePage) {
          targetRoute = '/business-information';
        }
        break;

      case 'NRSPAY':
        if (this.nrspayPlansPage) {
          targetRoute = '/subscription';
        } else if (this.isSummaryPage) {
          targetRoute = '/bank-page';
        }
        break;

      default:
        break;
    }

    // If the current page has unsaved changes, ask the user what to do before
    // leaving via Back. Otherwise navigate straight away.
    if (this.headerService.isCurrentPageDirty()) {
      this.pendingStepRoute = targetRoute;
      this.openUnsavedChangesModal();
    } else {
      this._navigate(targetRoute, false);
    }
  }

  /**
   * Navigates to the specified route using the Angular router.
   * @param route The target route string (e.g., '/some-page').
   * @param replaceUrl Whether to replace the current URL in history. Defaults to true for back navigation.
   */
  private _navigate(route: string | undefined | null, replaceUrl: boolean = true): void {
    console.log("Attempting to navigate to:", route);
    console.log("replaceUrl:", replaceUrl);
    // Clear the outgoing page's dirty check so it can never leak into the next
    // page; the destination re-registers its own check in ngOnInit.
    this.headerService.dirtyCheck = null;
    if (route) {
      // Ensure the route starts with '/' for consistency if needed, though split handles both cases
      const routeSegments = route.startsWith('/') ? route.substring(1).split('/') : route.split('/');
      // Prepend root segment if necessary, split('/') on '/foo' results in ["", "foo"]
      const finalSegments = routeSegments[0] === '' ? routeSegments : ['/', ...routeSegments];

      this.router.navigate(finalSegments, { replaceUrl: replaceUrl });
    } else {
      console.warn("Attempted to navigate with an undefined or empty route. Check page configuration for:", this.currentPage);
    }
  }

  closePantherWebView() {
    if (window.AndroidInterface && typeof window.AndroidInterface.closeWebView === 'function') {
      window.AndroidInterface.closeWebView();
    } else {
      alert("Close action not supported.");
    }
  }
}
